<template>
  <div>
    <!-- <el-form label-position="left" :inline="true" v-if="show">
      <el-form-item :label="item.name" v-for="(item, index) in config" :key="index" :required="item.required">
        <div :class="item.class">
          <el-input v-model="localValue[item.key]" :placeholder="'输入' + item.name" v-if="!item.type"></el-input>
        </div>
      </el-form-item>
    </el-form> -->

    <div class="acsb">
      <div v-for="(item, index) in config" :key="index">
        <div :class="getColumnStyle(item)" class="tac mb4" style="line-height: normal">{{ item.name }}</div>
        <div :class="getColumnStyle(item)" style="line-height: 40px">
          <div v-if="!item.type">
            <el-input v-model="localValue[item.key]" :placeholder="'输入' + item.name" v-if="!item.type"></el-input>
          </div>
          <div v-if="item.type === 'switch'">
            <el-switch v-model="localValue[item.key]"> </el-switch>
          </div>
          <div v-if="item.type === 'select'">
            <el-select v-model="localValue[item.key]" placeholder="请选择">
              <el-option v-for="option in item.options" :key="option" :label="option" :value="option"> </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { http_post, http_get } from '@/api/api'
import _ from 'lodash'

export default {
  props: {
    value: {
      type: null,
      default: () => null
    },
    config: {
      type: Array,
      default: () => null
    }
  },
  data() {
    return {
      show: false,
      localValue: _.cloneDeep(this.value) // 深拷贝初始化
    }
  },
  watch: {
    localValue: {
      handler(newVal) {
        if (!this.isEqual(newVal, this.value)) {
          this.$emit('input', _.cloneDeep(newVal)) // 值变化时通知父级
        }
      },
      deep: true
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      // 加载所有选项的数据
      let index = 1
      for (const item of this.config) {
        if (item.default) {
          if (!this.localValue.hasOwnProperty(item.key)) {
            this.$set(this.localValue, item.key, item.default)
          }
        }
      }
      this.show = true
    },

    isEqual(a, b) {
      // 智能值比对（处理所有数据类型）
      if (typeof a !== typeof b) return false
      if (typeof a === 'object' && a !== null && b !== null) {
        // 处理引用类型
        return _.isEqual(a, b) // 使用 lodash 深度比对
      }
      return a === b // 基本类型直接比对
    },
    getColumnStyle(column) {
      if (column.class) {
        return column.class
      } else {
        return 'flex1'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 10px;
}
</style>
